import { IApplicationState } from '../../types/redux';

export const selectIsCPDModalOpen = (state: IApplicationState): boolean => {
  const isAvailable = state.cpd.isAvailable;

  if (!isAvailable) {
    return false;
  }

  return state.cpd.isModalOpen;
};
